export default "/images/vendor/flag-icons/flags/1x1/bn.svg?380e5d576317bd86523b2ebdcacab69f";